import React from "react";
import { Link } from "react-router-dom";
import blogdata from "./blogdata"; // adjust path as needed
import "./blog.css";

function Blog() {
  return (
    <div className="blog-container">
      <h1>Blogs</h1>
      <div className="blog-grid">
        {blogdata.map((blog, index) => (
          <Link to={`/blog/${blog.slug}`} className="blog-card" key={index}>
            <div className="blog-image">
              {blog.img && <img src={blog.img} alt={blog.name} />}
            </div>
            <p>{blog.name}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Blog;
